import type { AspectRatio } from "../../../../aysa_api/features/ui/v1/aspect_ratio.types";
import { Reader, Writer } from "protobufjs/minimal";
import type { Long } from "protoc-gen-ts";

export const createBaseAspectRatio = (): AspectRatio => {
  return {
    width: 0,
    height: 0,
  };
};

export const decodeAspectRatio = (
  reader: Reader,
  length: number
): AspectRatio => {
  const end = reader.pos + length;
  const message = createBaseAspectRatio();

  while (reader.pos < end) {
    const tag = reader.uint32();
    switch (tag >>> 3) {
      case 1:
        message.width = (reader.int64() as Long).toNumber();

        break;
      case 2:
        message.height = (reader.int64() as Long).toNumber();

        break;

      default:
        reader.skipType(tag & 7);
        break;
    }
  }

  return message;
};

export const encodeAspectRatio = (
  writer: Writer,
  message: AspectRatio
): Writer => {
  writer.uint32(8).int64(message.width);
  writer.uint32(16).int64(message.height);

  return writer;
};
